import * as Yup from "yup";
import moment from "moment";

export const transactionSearchReportInitialValues = {
  merchantID: "",
  terminalID: "",
  currency: "USD",
  amount: "",
  exchangeName: "",
  requestDate: "",
};

export const transactionSearchReportValidationSchema = Yup.object().shape({
  merchantID: Yup.string().required("Merchant ID is required"),
  terminalID: Yup.string(),
  currency: Yup.string().required("Currency is required"),
  amount: Yup.string(),
  exchangeName: Yup.string(),
  requestDate: Yup.string()
    .required("Request Date is required")
    .matches(/^\d{8}$/, "Invalid date")
    .test(
      "max-today",
      "Date cannot be in the future",
      (value) => {
        if (!value) return false;
        const m = moment(value, "YYYYMMDD");
        return m.isValid() && m.isSameOrBefore(moment(), "day");
      },
    ),
});
